// @flow
import classNames from 'classnames';
import * as React from 'react';

// Styles
import styles from './Actions.scss';

type PropTypes = {
  children?: React.Node,
  classes?: {
    root?: string
  }
};

const FormActions = ({
  children,
  classes = {}
}: PropTypes): React.Element<'div'> => (
  <div className={classNames(classes.root, styles.Root)}>{children}</div>
);

export default FormActions;
